export const TaxCalcualate = (taxdata: any, total_price?: number, quantity?: number) => {
  let fixedTax: number = 0;
  let percentageTax: number = 0;
  const taxArray: any = [];
  let tax_inclusive_exclusive_type: any = ''
  // console.log("_tax_data", taxdata.map_tax_class)
  taxdata?.map_tax_class?.map((tax: any) => {
    // console.log("_tax", tax)
    if (tax?.tax_rate[0]?.tax_type == "fixed") {
      taxArray.push({
        tax_id: tax?.tax_rate[0].id,
        tax_name: tax?.tax_rate[0].tax_name,
        tax_type: tax?.tax_rate[0].tax_type,
        tax_amount: tax?.tax_rate[0]?.tax_amount,
        actual_tax_amount: tax?.tax_rate[0]?.tax_amount * (quantity || 0),
        tax_inclusive_exclusive_type: tax?.tax_rate[0]?.type
      });
      tax_inclusive_exclusive_type = tax?.tax_rate[0]?.type
      fixedTax += tax?.tax_rate[0].tax_amount;
    } else {
      taxArray.push({
        tax_id: tax?.tax_rate[0].id,
        tax_name: tax?.tax_rate[0].tax_name,
        tax_type: tax?.tax_rate[0].tax_type,
        tax_amount: tax?.tax_rate[0]?.tax_amount,
        actual_tax_amount: (Number(total_price) * tax?.tax_rate[0]?.tax_amount) / 100,
        tax_inclusive_exclusive_type: tax?.tax_rate[0]?.type
      });

      tax_inclusive_exclusive_type = tax?.tax_rate[0]?.type
      percentageTax += tax?.tax_rate[0].tax_amount;
    }
  });
  // console.log("__tax_value",taxdata,fixedTax,percentageTax,taxArray,total_price,quantity)
  return { fixedTax, percentageTax, taxArray,tax_inclusive_exclusive_type };
};
